import type { Args } from 'webapp/components/templates/recommended-base';
import TemplatesPublicRecommendedBaseComponent from 'webapp/components/templates/recommended-base';

import type Template from 'webapp/models-custom/template';

export default class TemplatesPublicRecommendedBoardLoopsComponent<
	T extends Args,
> extends TemplatesPublicRecommendedBaseComponent<T> {
	redirectRoute = 'boards.public-templates.index';
	defaultOrigin = 'recommended_loop_templates';
	override filterHash = 'all|all|2';

	override get title() {
		return 'Start with one of our popular templates...';
	}

	get model(): Template[] {
		return this.mmTemplatesService.getRecommendedBoardLoopPublicTemplateModels(
			this.maxItemsShown,
		);
	}

	requestTemplates() {
		return this.mmTemplatesService.requestBoardLoopPublicTemplates();
	}

	onTemplateUse(model: Template): void {
		this.onBoardLoopTemplateUse(model);
	}
}
